/**
 * @generated SignedSource<<1d591f60c4dcca8e281170e4b6422f04>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

import PractitionersTableRefetch_graphql from './PractitionersTableRefetch.graphql';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "firstName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "lastName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "legalContractName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "locationName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "npi"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tin"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": PractitionersTableRefetch_graphql
    }
  },
  "name": "PractitionersTableFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "firstName",
              "variableName": "firstName"
            },
            {
              "kind": "Variable",
              "name": "lastName",
              "variableName": "lastName"
            },
            {
              "kind": "Variable",
              "name": "legalContractName",
              "variableName": "legalContractName"
            },
            {
              "kind": "Variable",
              "name": "locationName",
              "variableName": "locationName"
            },
            {
              "kind": "Variable",
              "name": "npi",
              "variableName": "npi"
            },
            {
              "kind": "Variable",
              "name": "tIN",
              "variableName": "tin"
            }
          ],
          "kind": "ObjectValue",
          "name": "input"
        }
      ],
      "concreteType": "Practitioner",
      "kind": "LinkedField",
      "name": "filteredPractitioners",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "LegalContract",
          "kind": "LinkedField",
          "name": "legalContract",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PractitionerIdentifier",
          "kind": "LinkedField",
          "name": "identifiers",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "IdentifierType",
              "kind": "LinkedField",
              "name": "identifierType",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PractitionerVersion",
          "kind": "LinkedField",
          "name": "applicableVersion",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

node.hash = "e4ceb9874de313228b70f9a2da085fac";

export default node;
